import { createContext, useContext } from 'react';

import type { NodePreviewDomain } from './nodePreviewStore';

/**
 * PTV2-1328 / PTV2-1391 — provided by `NodeRecordPanel` (the pedigree node-edit panel) and consumed by
 * the shared record cards so they push a LIVE graph-node preview of their draft. Each card publishes
 * its own DOMAIN (`demographics` from `PersonalInfoCard`, `pedigreeProps` from `PedigreeAttributesCard`,
 * …) so the domains stay independent. On the plain patient record there is no provider, so
 * `useNodeGraphPreview()` returns null and the cards behave exactly as before (no graph to preview).
 */
export interface NodeGraphPreview {
  /** Publish this node's projected overlay for the given domain (pre-save live preview). */
  readonly publish: (domain: NodePreviewDomain, overlay: Record<string, unknown>) => void;
  /** Drop this node's preview for a domain (call on unmount), or all domains when omitted. */
  readonly clear: (domain?: NodePreviewDomain) => void;
}

export const NodeGraphPreviewContext = createContext<NodeGraphPreview | null>(null);

/** The graph-node preview channel for the current node, or null when not inside a pedigree panel. */
export function useNodeGraphPreview(): NodeGraphPreview | null {
  return useContext(NodeGraphPreviewContext);
}
